<template>
  <v-card :to="to" class="platform-kpi" :class="{ 'platform-kpi--alert': alert }" outlined>
    <v-card-text class="d-flex align-center">
      <v-avatar :color="`${color} lighten-5`" size="48" class="mr-4">
        <v-icon :color="`${color} darken-1`">{{ icon }}</v-icon>
      </v-avatar>
      <div class="flex-grow-1 min-width-0">
        <div class="text-caption grey--text text--darken-1 text-truncate">{{ label }}</div>
        <div class="text-h5 font-weight-bold" :class="`${color}--text text--darken-2`">
          {{ value }}
        </div>
        <div v-if="hint" class="text-caption grey--text text-truncate">{{ hint }}</div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
/**
 * Tarjeta de indicador del panel de plataforma. `alert` resalta el borde para
 * métricas que exigen acción (suscripciones vencidas, fallos de provisioning).
 */
export default {
  name: 'PlatformKpiCard',
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], required: true },
    icon: { type: String, default: 'mdi-chart-box-outline' },
    color: { type: String, default: 'indigo' },
    hint: { type: String, default: '' },
    alert: { type: Boolean, default: false },
    to: { type: [String, Object], default: null },
  },
};
</script>

<style scoped>
.platform-kpi {
  height: 100%;
}

.platform-kpi--alert {
  border-color: #ef5350 !important;
  border-width: 1px;
}

.min-width-0 {
  min-width: 0;
}
</style>
